<app-top-progress-bar />
<app-header></app-header>
<main class="app-content">
  <router-outlet></router-outlet>
</main>
